import { BaseHTMLAttributes, FC } from 'react';

export type SectionPadding = 'zero' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export const SECTION_PADDING = {
  Zero: 'zero',
  Xs: 'xs',
  Sm: 'sm',
  Md: 'md',
  Lg: 'lg',
  Xl: 'xl',
};

export interface SectionProps extends BaseHTMLAttributes<HTMLDivElement> {
  isFullHeight?: boolean;
  padding: SectionPadding;
  backgroundColor?: string;
}

const applyMainStyles =
  ({
    isFullHeight,
    padding,
    backgroundColor,
  }: Pick<SectionProps, 'isFullHeight' | 'padding' | 'backgroundColor'>) =>
  (theme) => ({
    backgroundColor: backgroundColor || theme.section.backgroundColor,
    ...(isFullHeight && { height: '100vh' }),
    width: '100%',
    ...theme.section.Padding[padding],
  });

export const Section: FC<SectionProps> = ({
  children,
  className,
  isFullHeight = false,
  padding = 'sm',
  backgroundColor,
  ...props
}: SectionProps) => (
  <section
    className={className}
    css={applyMainStyles({ isFullHeight, padding, backgroundColor })}
    {...props}
  >
    {children}
  </section>
);
